import React from 'react'
import { Navigate, useParams, useSearchParams } from 'react-router-dom'
export default function MemberOpenGroupsPage({ clubCode }) {
  const { courseId } = useParams()
  const [search] = useSearchParams()
  return <Navigate replace to={`/${clubCode}/golf/${courseId}?${search.toString()}`} />
}
